import React, { useEffect, useState, useCallback } from 'react';
import AntLocalization from '../utils/AntLocalization';
import AntWidgetSkeleton from './AntWidgetSkeleton';
import useWidgetFirstLoad from './AntWidgetSkeleton/useWidgetFirstLoad';

export default function (props) {
    var [data, setData] = useState({});
    var [loaded, markLoaded] = useWidgetFirstLoad(Boolean(props.url));

    var load = useCallback(async () => {
        if (props.url) {
            props.API.post(props.url, { ...props.searchConditions }, (resp) => {
                if (resp && !resp.error && resp.data) setData(resp.data);
                else setData({});
                markLoaded();
            });
        }
    }, [props.API, props.url, props.searchConditions, markLoaded]);

    useEffect(() => {
        load();
        var ms = ((props.refreshIntervalSec ?? 60) | 0) * 1000;
        if (ms <= 0) return;
        var interval = setInterval(load, ms);
        return () => clearInterval(interval);
    }, [load, props.refreshIntervalSec]);

    useEffect(() => {
        load();
    }, [props.searchConditions, props.url]);

    var formatValue = (val, dataType) => {
        if (val === undefined || val === null) return '0';
        var num = parseFloat(val);
        if (isNaN(num)) return String(val);
        if (dataType === 'currency') return AntLocalization.translateCurrency(num);
        if (dataType === 'int') return AntLocalization.translateInteger(num);
        if (dataType === 'float') return AntLocalization.translateDecimal(num);
        if (dataType === 'percent') return (num * 100).toFixed(1) + '%';
        return String(val);
    };

    var mainValue = data[props.mainField] || 0;
    var changePercent = data[props.changeField];
    var trend = data[props.trendField] || props.trend;

    if (!trend && changePercent !== undefined) {
        var cp = parseFloat(changePercent);
        trend = cp > 0 ? 'up' : cp < 0 ? 'down' : 'neutral';
    }

    var trendCls = trend === 'up' ? ' ant-widget-metric-card--up' : trend === 'down' ? ' ant-widget-metric-card--down' : '';

    if (!loaded) return <AntWidgetSkeleton variant="metric" />;

    return (
        <React.Fragment>
            <div className={'ant-widget-metric-card' + trendCls}>
                <div className="ant-widget-metric-card__caption">{AntLocalization.translateText(props.caption || props.title)}</div>
                <div className="ant-widget-metric-card__main">
                    <span className="ant-widget-metric-card__value">{formatValue(mainValue, props.mainDataType)}</span>
                    {trend && trend !== 'neutral' && (
                        <span className="ant-widget-metric-card__trend">{trend === 'up' ? '\u25B2' : '\u25BC'}</span>
                    )}
                </div>
                {(changePercent !== undefined || props.compareLabel) && (
                    <div className="ant-widget-metric-card__compare">
                        {changePercent !== undefined && (
                            <span className="ant-widget-metric-card__change">
                                {parseFloat(changePercent) > 0 ? '+' : ''}
                                {parseFloat(changePercent).toFixed(1)}%
                            </span>
                        )}
                        {props.compareLabel && (
                            <span className="ant-widget-metric-card__compare-label">
                                {' '}
                                {AntLocalization.translateText(props.compareLabel)}
                            </span>
                        )}
                    </div>
                )}
            </div>
        </React.Fragment>
    );
}
